import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs';

import { toSignal } from '@angular/core/rxjs-interop';
import { FooterService } from './footer.service';
import { GlobalStateService } from './global-state.service';
import { GoogleTagAnalyticsService } from './google-tag';
import { SportsService } from './sport.service';

@Injectable({
  providedIn: 'root',
})
export class RouteValidatorService {
  private router = inject(Router);
  private activeRoute = inject(ActivatedRoute);
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);
  private globalStateService = inject(GlobalStateService);
  private footerService = inject(FooterService);
  private sportService = inject(SportsService);

  // ✅ matchId como Signal, usando toSignal para convertir el observable
  readonly matchId = toSignal(
    this.activeRoute.paramMap.pipe(map((params) => params.get('matchId'))),
    { initialValue: null }
  );

  // ✅ currentUrl actualizado correctamente con NavigationEnd
  readonly currentUrl = toSignal(
    this.router.events.pipe(
      tap(() => {
        this.footerService.selectedSport.set(
          this.sportService.getSelectedSport()
        );
        if (this.globalStateService.handleMenu()) {
          this.globalStateService.toogleMenu();
        }
      }),
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects)
    ),
    { initialValue: this.router.url }
  );

  handleChangeUrlGoogleTagManager =
    // ✅ Escuchar cambios de navegación y actualizar la señal
    effect(() => {
      const auth: any = localStorage.getItem('auth') || '';

      this.googleTagAnalyticsService.event('page_view_context', {
        path: this.currentUrl(),
        url: window.location,
        title: document.title,
        lang: navigator.language,
        user_id: auth ? auth.user.id : '',
        logged_in: auth ? 'true' : 'false',
        // country: navigator.,
      });
    });

  // ✅ Computed para verificar si contiene una parte específica
  handleValidUrlSignal = (url: string) =>
    computed(() => this.currentUrl().includes(url));

  // ✅ Otras validaciones
  readonly onlyShowToritoPage = computed(() =>
    this.currentUrl().includes('/loteriaTorito')
  );

  readonly onlyShowFutbolPage = computed(() =>
    this.currentUrl().includes('/Futbol/todos-los-partidos')
  );
  readonly isFavoritePage = computed(() =>
    this.currentUrl().includes('/favorites/all')
  );

  readonly isFutbolSelected = computed(() => {
    const url = new URL(this.currentUrl(), window.location.origin); // asegura base
    const segments = url.pathname.split('/').filter(Boolean); // elimina vacíos

    // Si el primer segmento es 'en', el segundo será 'football'
    // Si no hay prefijo, el primero será 'futbol'
    const futPath =
      segments[0] === 'en'
        ? segments[1]?.toLowerCase()
        : segments[0]?.toLowerCase();

    return ['futbol', 'football'].includes(futPath);
    // const futPath = this.currentUrl().split('/')[1]?.toLowerCase();
    // return ['futbol', 'football'].includes(futPath);
  });

  readonly isNoticeRouteSelected = computed(() => {
    const path = this.currentUrl().split('/')[1]?.toLowerCase();
    return ['noticias', 'news'].includes(path) || path === 'noticias';
  });

  readonly isFavoriteRouteSelected = computed(() => {
    const path = this.currentUrl().split('/')[1]?.toLowerCase();
    return path === 'favorites';
  });

  readonly isActiveTabCompetitionFavorite = signal(false);
  readonly isActiveTabTeamFavorite = signal(false);
}
